import { render, staticRenderFns } from "./imgContent.vue?vue&type=template&id=304807f8&scoped=true&"
import script from "./imgContent.vue?vue&type=script&lang=js&"
export * from "./imgContent.vue?vue&type=script&lang=js&"
import style0 from "./imgContent.vue?vue&type=style&index=0&id=304807f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304807f8",
  null
  
)

export default component.exports